// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + "28d71b32" + ".chunk.css");